import React from 'react';
import { Button, Alert, Label } from 'reactstrap';
import { ModalFooter, ModalBody } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import HelpIconTooltip from '~/components/helpIconTooltip/helpIconTooltip';
import ProductOptions from '~/containers/productOptions/productOptions';
import TransferScheduleOptions from '~/containers/transferScheduleOptions/transferScheduleOptions';
import { helpText } from './constants';

const LotModalForm = ({ values, errors, touched, handleSubmit, isSubmitting, onCancelClick }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <ModalBody>
        <div className="mb3">
          <Label>Which product?</Label>
          <FormikInputField type="select" name="productId" invalid={!!errors.productId}>
            <ProductOptions />
          </FormikInputField>
          {errors.productId && (
            <p data-qa="productId-error" className="error">
              {errors.productId}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>When are you brewing?</Label>
          <FormikInputField type="date" name="startDate" invalid={!!errors.startDate} />
          {errors.startDate && (
            <p data-qa="startDate-error" className="error">
              {errors.startDate}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>How much (in litres)?</Label>
          <FormikInputField type="number" name="volume" invalid={!!errors.volume} />
          {errors.volume && (
            <p data-qa="volume-error" className="error">
              {errors.volume}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>What schedule should it follow?</Label>
          <FormikInputField type="select" name="transferScheduleId" invalid={!!errors.transferScheduleId}>
            <TransferScheduleOptions isConsolidated={false} />
          </FormikInputField>
          {errors.transferScheduleId && (
            <p data-qa="transferScheduleId-error" className="error">
              {errors.transferScheduleId}
            </p>
          )}
        </div>
        <div className="mb3 checkbox-container">
          <Label>
            <FormikInputField type="checkbox" name="isSample" checked={values.isSample} />
            Is this a sample brew only?
            <HelpIconTooltip className="ml2" text={helpText} />
          </Label>
        </div>
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancelClick}>
          Cancel
        </Button>{' '}
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Schedule
        </SubmissionButton>
      </ModalFooter>
    </form>
  );
};

export default LotModalForm;



// WEBPACK FOOTER //
// ./src/components/lotModalForm/lotModalForm.jsx